<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <!-- PROBLEM: now we use this button for prefill with production package data-->
      <!-- TODO: fix hard code  -->
      <div v-show="isStagingENV" class="text-end">
        <el-input
          v-model="productionPackageId"
          class="input production-package-id"
        ></el-input>
        <sc-button @click="handlePrefillData"
          >Prefill Data From Production</sc-button
        >
      </div>
      <package-editor
        v-model="form"
        :image-url="imageUrl"
        :thumbnail-url="thumbnailUrl"
        :targets="targets"
        :seller-trade-parties="sellerTradeParties"
        class="mb-4"
      ></package-editor>
      <div class="text-end">
        <sc-button disabled variant="primary" @click="handleClickSave"
          >บันทึก</sc-button
        >
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input } from "element-ui"
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import { uploadPublicImage } from "@/god"
import { isNil } from "ramda"
import { toOptionalDateTime, toOptionalISOString } from "@/lib/dateTime"
import { toCamelCaseObject } from "@/lib/util"
import { convertBathToStangAndRoundTwoDecimal } from "@/lib/formatter"
import PackageEditor from "../components/PackageEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageEditor,
    "el-input": Input,
  },
  data() {
    const title = "เพิ่ม Ruejai Club Sale Package"
    const form = {
      name: "",
      receiptName: "",
      target: "สำหรับบ้าน",
      price: 0,
      billingCycle: 1,
      detail: "",
      termsAndConditions: "",
      sellerTradePartyId: null,
      services: [],
      imageFile: null,
      thumbnailFile: null,
      noteLabel: null,
      registrationForm: null,
      hasRegistrationForm: false,
      purchasingLimit: null,
      originalPrice: null,
      purchaseSuccessTitle: null,
      purchaseSuccessMessage: null,
      expiredAt: null,
    }

    const imageUrl = null
    const thumbnailUrl = null
    const targets = []
    const sellerTradeParties = []
    const productionPackageId = null
    const isPrefilByProductionPackage = false

    return {
      title,
      form,
      imageUrl,
      thumbnailUrl,
      targets,
      sellerTradeParties,
      productionPackageId,
      isPrefilByProductionPackage,
    }
  },
  computed: {
    isStagingENV() {
      return process.env.DEPLOY_ENV === "staging"
    },
  },
  watch: {
    form(form, oldForm) {
      if (this.form.imageFile !== oldForm.imageFile) {
        this.imageUrl = URL.createObjectURL(this.form.imageFile)
      }

      if (this.form.thumbnailFile !== oldForm.thumbnailFile) {
        this.thumbnailUrl = URL.createObjectURL(this.form.thumbnailFile)
      }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    async setupData() {
      await this.setupTargets()
      await this.setupSellerTradeParties()
      await this.setupForm()
    },
    async setupTargets() {
      const targets = await this.fetchTargets()

      this.targets = targets
    },
    async setupSellerTradeParties() {
      const sellerTradeParties = await this.fetchSellerTradeParties()

      this.sellerTradeParties = sellerTradeParties
    },
    async setupForm() {
      if (!this.$route.query.id && !this.isPrefilByProductionPackage) {
        return
      }

      const data = this.isPrefilByProductionPackage
        ? await this.fetchProductionPackageData()
        : await this.fetchData()
      /* eslint-disable camelcase -- API response */
      const {
        name,
        receipt_name: receiptName,
        detail,
        target,
        price,
        billing_cycle: billingCycle,
        terms_and_conditions: termsAndConditions,
        seller_trade_party_id: sellerTradePartyId,
        image_url: imageUrl,
        services,
        thumbnail_url: thumbnailUrl,
        note_label,
        registration_form,
        purchasing_limit: purchasingLimit,
        original_price,
        purchase_success_title: purchaseSuccessTitle,
        purchase_success_message: purchaseSuccessMessage = null,
        expired_at: expiredAt,
      } = data

      this.form = {
        name,
        receiptName,
        detail,
        target,
        price: convertBathToStangAndRoundTwoDecimal(price),
        billingCycle,
        termsAndConditions,
        sellerTradePartyId,
        services: services.map((service) => ({
          ...service,
          iconUrl: service.icon_url,
          provider: {
            ...service.provider,
            logoUrl: service.provider.logo_url,
          },
        })),
        imageFile: null,
        thumbnailFile: null,
        noteLabel: note_label,
        registrationForm: toCamelCaseObject(registration_form),
        hasRegistrationForm: !!registration_form,
        purchasingLimit,
        originalPrice: !isNil(original_price)
          ? convertBathToStangAndRoundTwoDecimal(original_price)
          : null,
        purchaseSuccessTitle,
        purchaseSuccessMessage,
        expiredAt: toOptionalDateTime(expiredAt),
      }
      /* eslint-enable camelcase */
      this.imageUrl = imageUrl
      this.thumbnailUrl = thumbnailUrl
    },
    async fetchData() {
      const { id } = this.$route.query

      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.get(id)

      return response.data.result
    },
    async fetchProductionPackageData() {
      const id = this.productionPackageId

      const response =
        await baanRueJaiClient.admin.ruejaiClub.salePackages.getProductionPackage(
          id,
        )

      return response.data.result
    },
    fetchTargets() {
      return Promise.resolve([
        { id: "0", name: "สำหรับบ้าน" },
        { id: "1", name: "สำหรับคอนโด" },
        { id: "2", name: "สำหรับบ้านขนาดใหญ่" },
      ])
    },
    async fetchSellerTradeParties() {
      const response =
        await baanRueJaiClient.admin.subscriptions.receipts.getSellerTradeParties()

      return response.data.result
    },
    async handleClickSave() {
      if (this.isOriginalPriceLessThanOrEqualPrice()) {
        this.$message.error(
          "ไม่สามารถบันทึกได้เนื่องจากราคาเต็มน้อยกว่าหรือเท่ากับราคาที่ลดแล้ว",
        )
        return
      }
      if (this.form.price < 0) {
        this.$message.error("ไม่สามารถบันทึกได้เนื่องจากใส่ราคาไม่ถูกต้อง")
        return
      }
      if (this.form.billingCycle < 0) {
        this.$message.error("ไม่สามารถบันทึกได้เนื่องจากใส่รอบตัดบิลไม่ถูกต้อง")
        return
      }
      if (isNil(this.form.sellerTradePartyId)) {
        this.$message.error(
          "ไม่สามารถบันทึกได้เนื่องจากยังไม่ได้เลือกผู้จัดหาบริการ",
        )
        return
      }

      try {
        await this.createPackage()
        this.$router.push({ name: "RuejaiClubSalePackageListPage" })
      } catch (err) {
        if (err.response.status === 400) {
          this.$message.error(err.response.data.message)
          // eslint-disable-next-line no-console
          console.error(err)
        } else {
          this.$message.error(err.message)
          // eslint-disable-next-line no-console
          console.error(err)
        }
      }
    },
    async createPackage() {
      const {
        name,
        receiptName,
        target,
        price,
        billingCycle,
        detail,
        termsAndConditions,
        sellerTradePartyId,
        services,
        imageFile,
        thumbnailFile,
        noteLabel,
        registrationForm,
        purchasingLimit,
        originalPrice,
        purchaseSuccessTitle,
        purchaseSuccessMessage,
        expiredAt,
      } = this.form

      const imageUrl = imageFile
        ? await uploadPublicImage(imageFile)
        : this.imageUrl
      const thumbnailUrl = thumbnailFile
        ? await uploadPublicImage(thumbnailFile)
        : this.thumbnailUrl
      const serviceIds = services.map(({ id }) => id)

      const params = {
        name,
        receiptName,
        target,
        price: price * 100,
        billingCycle,
        detail,
        termsAndConditions,
        sellerTradePartyId,
        serviceIds,
        image: imageUrl,
        thumbnail: thumbnailUrl,
        noteLabel,
        isSecret: false,
        registrationForm,
        purchasingLimit,
        originalPrice: originalPrice !== null ? originalPrice * 100 : null,
        purchaseSuccessTitle,
        purchaseSuccessMessage,
        expiredAt: toOptionalISOString(expiredAt),
      }

      const subscriptionResponse =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.post(
          params,
        )
      const { id } = subscriptionResponse.data.result
      const response =
        await baanRueJaiClient.admin.ruejaiClub.salePackages.post({
          subscription_package_id: id,
        })

      return response
    },
    isOriginalPriceLessThanOrEqualPrice() {
      return (
        this.form.originalPrice !== null &&
        this.form.originalPrice <= this.form.price
      )
    },
    // PROBLEM: now we hard code for prefill data with production package data
    // TODO: fix hard code
    handlePrefillData() {
      this.isPrefilByProductionPackage = true
      this.setup()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.production-package-id {
  width: 100px;
}

.editor {
  margin-bottom: $space;
}
</style>
